<div class="dev-image-viewer" [style.backgroundImage]="'url(' + imageUrl + ')'"></div>
